import React from 'react';
import styled from 'styled-components';
import { Box } from '@99designs/emu';
import { mediaQuery } from '@99designs/emu/css';
import { spaces } from '@99designs/emu/settings';
import { DWB21_Green, DWB21_Peach, DWB21_Purple, DWB21_Teal } from '../colors';
import DiversityBarChart from './DiversityBarChart';

const Wrapper = styled.div`
    columns: 1 auto;
    ${mediaQuery.between('medium', 'large')} {
        columns: 2 auto;
    }
    ${mediaQuery.only('large')} {
        columns: 4 auto;
    }
`;

const TopBorderBox = styled(Box)`
    border-top: 1px solid;
    margin-bottom: ${spaces['1.5bu']};
`;

export default function BarChartList() {
    return (
        <Wrapper>
            <ChartContainer>
                <TopBorderBox />
                <DiversityBarChart
                    calloutStat="1 in 3"
                    calloutDescription="identify as female"
                    score={40} // This is a cheat value to make chart look visually pleasing
                    barChartColor={DWB21_Teal}
                />
            </ChartContainer>
            <ChartContainer>
                <TopBorderBox />
                <DiversityBarChart
                    calloutStat="11%"
                    calloutDescription="have held refugee status at some point in their life"
                    score={24} // This is a cheat value to make chart with smaller values look visually pleasing
                    barChartColor={DWB21_Purple}
                />
            </ChartContainer>
            <ChartContainer>
                <TopBorderBox />
                <DiversityBarChart
                    calloutStat="8%"
                    calloutDescription="are first-generation children of immigrants"
                    score={20} // This is a cheat value to make chart with smaller values look visually pleasing
                    barChartColor={DWB21_Peach}
                />
            </ChartContainer>
            <ChartContainer>
                <TopBorderBox />
                <DiversityBarChart
                    calloutStat="32%"
                    calloutDescription="of designers have moved countries to live and work abroad"
                    score={40} // This is a cheat value to make chart look visually pleasing
                    barChartColor={DWB21_Green}
                />
            </ChartContainer>
        </Wrapper>
    );
}
interface ChartContainerProps {
    children: React.ReactNode;
}
function ChartContainer({ children }: ChartContainerProps) {
    return (
        <Box paddingRight={['none', '4bu', '4bu', '2bu']} paddingBottom={['2bu', '4bu']}>
            {children}
        </Box>
    );
}
